import React from 'react'
import { Route } from 'react-router'
import * as Sentry from '@sentry/react'
import ROUTES from '../constants/routes'
import withAuthHOC from '../../components/withAuthHOC/withAuthHOC'

const routesWithAuth = () => {
  const SentryRoute = Sentry.withSentryRouting(Route)

  return ROUTES.map((route) => {
    const {
      exact,
      path,
      component,
      noLayout,
      allowedOrgAddons,
      allowedAddons,
      allowedUserOrgRoles,
      payLocked,
      requiredPermission,
    } = route || {}

    return (
      <SentryRoute
        key={path}
        exact={exact}
        path={path}
        component={withAuthHOC(
          allowedOrgAddons,
          allowedAddons,
          allowedUserOrgRoles,
          payLocked,
          requiredPermission,
        )(component)}
        noLayout={noLayout}
      />
    )
  })
}

export default routesWithAuth
